/* eslint-disable react/jsx-props-no-multi-spaces */
import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Input, Label, Row } from 'reactstrap';
import DropdownSelect from '../../ProposalGenerator/DropdownSelect';
import CompanyAutocomplete from './../../CompanyAutocomplete';
const EMPTY_COMPANY = { value: null, label: '' };

const MainCGM = memo(({ state, onStateChange, groupItems }) => {
  const companiesDocs = useSelector(s => s.AppState.companies)?.docs || [];
  const formattedCompanies = useMemo(() => {
    return companiesDocs.map((c) => ({
      ...c,
      originalName: c.name,
      name: c.epikCustomerId
        ? `${c.name} - ${c.epikCustomerId}`
        : `${c.name || ''}`,
    }));
  }, [companiesDocs]);
  const selectedCompanyLabel = useMemo(() => {
    const existingLabel = state?.company?.label;
    if (existingLabel) return existingLabel;
    const selectedId = state?.company?.value;
    if (!selectedId) return '';
    const found = formattedCompanies.find(c => c._id === selectedId);
    return found?.name || found?.email || '';
  }, [state?.company?.label, state?.company?.value, formattedCompanies]);

  const handleCompanyAutoChange = evObj => {
    const comp = evObj?.suggestion;
    if (!comp) {
      onStateChange(EMPTY_COMPANY, 'company');
      return;
    }
    onStateChange(
      { value: comp._id, label: comp.name || comp.email || '' },
      'company'
    );
  };

  return (
    <div className="mt-3">
      <Row>
        <Col sm={4}>
          <Label className="mt-3">Group Name:</Label>
          <Input
            placeholder="Group Name"
            required
            type="text"
            name="name"
            value={state?.name || ''}
            onChange={e => onStateChange(e.target.value, 'name')}
          />
          <Label className="mt-3">Tag Name:</Label>
          <DropdownSelect
            options={groupItems}
            selectedOption={state.hostTag}
            onSelect={value => {
              onStateChange(value, 'hostTag');
              // addCompanyGroupChange({ name: 'hostTag', value: value.value });
            }}
          />
          <Label className="mt-3">Management Company:</Label>
          <CompanyAutocomplete
            companies={formattedCompanies}
            placeholder="Filter"
            searchTerm={selectedCompanyLabel}
            onChange={handleCompanyAutoChange}
            className="autocomplete-container"
            showWarning={false}
          />
        </Col>
      </Row>
    </div>
  );
});

export default MainCGM;
